import styles from "./PillTag.module.scss";
import { FormattedMessage } from "react-intl";
import { clsx } from "clsx";
import MiscellaneousCheckmarkCircleFill from "common/icons/MiscellaneousCheckmarkCircleFill.tsx";
import MiscellaneousXCircleFill from "common/icons/MiscellaneousXCircleFill.tsx";

export type PillType = "OptedIn" | "OptedOut";

export default function PillTag({
  type,
  count,
}: {
  type: PillType;
  count?: number;
}) {
  const isOptedIn = type === "OptedIn";

  const config = isOptedIn
    ? {
        variant: "vst-tag-variant-green-outline",
        Icon: MiscellaneousCheckmarkCircleFill,
      }
    : {
        variant: "vst-tag-variant-red-outline",
        Icon: MiscellaneousXCircleFill,
      };

  return (
    <div className={clsx("vst-tag", config.variant, styles.pill)}>
      <config.Icon aria-hidden="true" />
      <span>
        {isOptedIn ? (
          <FormattedMessage
            defaultMessage="{hasCount, select, true {{count} Opted In} other {Opted In}}"
            values={{ hasCount: String(count !== undefined), count }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="{hasCount, select, true {{count} Opted Out} other {Opted Out}}"
            values={{ hasCount: String(count !== undefined), count }}
          />
        )}
      </span>
    </div>
  );
}
